/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditErase = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22.094 6.43 6.516 22.009l-4.43-4.43L17.663 2h4.43zM4.915 17.579l1.602 1.602 2.104-2.105-1.601-1.601zm3.519-3.518 1.601 1.601L20.094 5.603V4h-1.602zM22 22H11v-2h11z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEditErase as EditErase };
